<div class="PGTickets">
    <div class="container-fluid">
        @if (priceOnRequest) {
            <div class="row PGTickets-Element PGTickets-Element-Heading border-bottom">
                <div class="col PGTickets-Col-Label">
                    @if (availabilitySelected.availability != null) {
                        <span class="{{ getSelectionTotalQuantity() > availabilitySelected.availability.current ? 'text-danger' : ''}}">
                            {{ 'pg-tickets-select.column-available' | locTranslate:'num':availabilitySelected.availability.current }}
                        </span>
                    }
                </div>
                <div class="col PGTickets-Col-Quantity">{{ 'pg-tickets-select.column-quantity' | locTranslate }}</div>
            </div>
            <div class="row PGTickets-Element">
                <div class="col PGTickets-Col-Label">{{ 'pg-tickets-select.label-price-on-request' | locTranslate }}</div>
                <div class="col PGTickets-Col-Quantity">
                    <input type="number" min="0" step="1" class="form-control form-control-sm" [ngModel]="selection.fullQuantity" (ngModelChange)="selection.fullQuantity = checkQuantity($event)"/>
                </div>
            </div>
        }
        @if (!priceOnRequest) {
            <div class="row PGTickets-Element PGTickets-Element-Heading border-bottom">
                <div class="col PGTickets-Col-Label">
                    @if (availabilitySelected.availability != null && availabilitySelected.availability.total != null) {
                        <span class="{{ getSelectionTotalQuantity() > availabilitySelected.availability.current ? 'text-danger' : ''}}">
                            {{ 'pg-tickets-select.column-available' | locTranslate:'num':availabilitySelected.availability.current }}
                        </span>
                    }
                </div>
                <div class="col PGTickets-Col-Price">{{ 'pg-tickets-select.column-price' | locTranslate }}</div>
                <div class="col PGTickets-Col-Quantity">{{ 'pg-tickets-select.column-quantity' | locTranslate }}</div>
            </div>
            @if (selection.fullPrice != null) {
                <div class="row PGTickets-Element">
                    <div class="col PGTickets-Col-Label">{{ 'pg-tickets-select.label-full-price' + (single ? '-single' : '') | locTranslate }}</div>
                    <div class="col PGTickets-Col-Price">
                        <span>{{formatPrice(selection.fullPrice, true)}}</span>
                    </div>
                    <div class="col PGTickets-Col-Quantity">
                        @if (!single) {
                            <input type="number" min="0" step="1" class="form-control form-control-sm" [ngModel]="selection.fullQuantity" (ngModelChange)="selection.fullQuantity = checkQuantity($event)"/>
                        }
                        @if (single) {
                            <input type="radio" name="{{randomId}}_single" class="form-check" value="full" [ngModel]="getSingleValue()" (ngModelChange)="setSingleValue('full')"/>
                        }
                    </div>
                </div>
            }
            @for (other of selection.otherTickets; track other; let i = $index) {
                <div class="row PGTickets-Element">
                    <div class="col PGTickets-Col-Label">{{formatTicketName(other.name)}}</div>
                    <div class="col PGTickets-Col-Price">
                        <span>{{formatPrice(other.price, true)}}</span>
                    </div>
                    <div class="col PGTickets-Col-Quantity">
                        @if (!single) {
                            <input type="number" min="0" step="1" class="form-control form-control-sm" [ngModel]="other.quantity" (ngModelChange)="other.quantity = checkQuantity($event)"/>
                        }
                        @if (single) {
                            <input type="radio" name="{{randomId}}_single" class="form-check" value="other{{i}}" [ngModel]="getSingleValue()" (ngModelChange)="setSingleValue('other' + i)"/>
                        }
                    </div>
                </div>
            }
            @if (!single) {
                <div class="row PGTickets-Element PGTickets-Total border-top">
                    <div class="col PGTickets-Col-Label">{{ 'pg-tickets-select.label-total' | locTranslate }}</div>
                    <div class="col PGTickets-Col-Price">{{formatPrice(getSelectionTotalPrice(), getSelectionTotalQuantity() > 0)}}</div>
                    <div class="col PGTickets-Col-Quantity">{{getSelectionTotalQuantity()}}</div>
                </div>
            }
        }
        <div class="row PGTickets-Buttons border-top pt-2">
            <div class="col">
                <button class="btn btn-primary float-end" [disabled]="!isSelectionValid()" (click)="ticketsSelected.emit(selection)">{{ 'pg-tickets-select.button-select' | locTranslate }}</button>
            </div>
        </div>
    </div>
</div>
